import AboutHero from '@/travo/components/sections/about/AboutHero';
import MissionLetter from '@/travo/components/sections/about/MissionLetter';
import WhyTravo from '@/travo/components/sections/about/WhyTravo';
import AboutCTA from '@/travo/components/sections/about/AboutCTA';
import { SEO } from '@/travo/components/SEO';
import { BreadcrumbSchema, WebPageSchema } from '@/shared/seo';
import { localizePath, useCopy, useLocale } from '@/travo/i18n';
import { APP_IDS, SITE_URL } from '@/shared/site';
import { ROUTES } from '@/travo/routes';

const AboutPage = () => {
  const copy = useCopy();
  const locale = useLocale();

  return (
    <>
      <SEO {...copy.seo.about} path={ROUTES.about} />
      <WebPageSchema
        name={copy.seo.about.title}
        description={copy.seo.about.description}
        url={SITE_URL + localizePath(locale, ROUTES.about)}
        inLanguage={copy.htmlLang}
        about={APP_IDS.travo}
      />
      <BreadcrumbSchema
        items={[
          { name: 'Travo', url: SITE_URL + localizePath(locale, ROUTES.home) },
          { name: copy.about.breadcrumbAbout, url: SITE_URL + localizePath(locale, ROUTES.about) }
        ]}
      />
      <main>
        <AboutHero />
        <MissionLetter />
        <WhyTravo />
        <AboutCTA />
      </main>
    </>
  );
};

export default AboutPage;
